import { forwardRef } from 'react'

/**
 * The dropdown chrome — the custom chevron and the room made for it.
 *
 * Exported so a field that needs its own markup (PlateField, which adds a text
 * box under the list) still looks like every other dropdown on the page, without
 * a second copy of the arrow that can drift out of step with this one.
 */
export const SELECT_ARROW_STYLE = {
  backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e")`,
  backgroundPosition: 'right 0.5rem center',
  backgroundSize: '1.5em 1.5em',
  paddingRight: '2.5rem',
}

export const selectClasses = (error, className = '') => `
  w-full px-3 py-2 border rounded-md transition-colors appearance-none
  bg-white bg-no-repeat bg-right
  ${error
    ? 'border-red-500 focus:ring-red-500'
    : 'border-gray-300 focus:ring-rdi-blue'}
  focus:outline-none focus:ring-2 focus:border-transparent
  disabled:bg-gray-100 disabled:cursor-not-allowed
  ${className}
`

const Select = forwardRef(({
  label,
  error,
  options = [],
  placeholder = 'Select...',
  className = '',
  ...props
}, ref) => {
  return (
    <div className="form-group">
      {label && (
        <label className="form-label">
          {label}
          {props.required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <select
        ref={ref}
        className={selectClasses(error, className)}
        style={SELECT_ARROW_STYLE}
        {...props}
      >
        {placeholder && (
          <option value="">{placeholder}</option>
        )}
        {options.map((option, index) => (
          <option
            key={option.value ?? index}
            value={option.value}
          >
            {option.label}
          </option>
        ))}
      </select>
      {error && (
        <p className="form-error">{error}</p>
      )}
    </div>
  )
})

Select.displayName = 'Select'

export default Select
